var __defProp = Object.defineProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
__export(exports, {
  calculateHomoClaveAndDigitalVerify: () => calculateHomoClaveAndDigitalVerify,
  calculateQuotient: () => calculateQuotient,
  equivalencesLetters: () => equivalencesLetters,
  equivalencesOne: () => equivalencesOne,
  equivalencesTwo: () => equivalencesTwo,
  formatTextRFC: () => formatTextRFC,
  getHomoclave: () => getHomoclave,
  inconvenientWords: () => inconvenientWords,
  isVowel: () => isVowel,
  names: () => names,
  removeInconvenientWords: () => removeInconvenientWords,
  removeNames: () => removeNames,
  removeWords: () => removeWords,
  toRemoveWords: () => toRemoveWords,
  vowelWithAccent: () => vowelWithAccent
});
const toRemoveWords = [
  " PARA ",
  " AND ",
  " CON ",
  " DEL ",
  " LAS ",
  " LOS ",
  " MAC ",
  " POR ",
  " SUS ",
  " THE ",
  " VAN ",
  " VON ",
  " AL ",
  " DE ",
  " EL ",
  " EN ",
  " LA ",
  " MC ",
  " MI ",
  " OF ",
  " A ",
  " E ",
  " Y "
];
const names = [" MARIA ", " JOSE ", " MA. ", " MA ", " J. ", " J ", " MAR\xCDA "];
const inconvenientWords = [
  "BUEI",
  "BUEY",
  "CACA",
  "CACO",
  "CAGA",
  "CAGO",
  "CAKA",
  "CAKO",
  "COGE",
  "COJA",
  "COJE",
  "COJI",
  "COJO",
  "CULO",
  "FETO",
  "GUEY",
  "JOTO",
  "KACA",
  "KACO",
  "KAGA",
  "KAGO",
  "KOGE",
  "KOJO",
  "KAKA",
  "KULO",
  "MAME",
  "MAMO",
  "MEAR",
  "MEAS",
  "MEON",
  "MION",
  "MOCO",
  "MULA",
  "PEDA",
  "PEDO",
  "PENE",
  "PUTA",
  "PUTO",
  "QULO",
  "RATA",
  "RUIN"
];
const equivalencesOne = {
  0: "00",
  C: "13",
  P: "27",
  1: "01",
  D: "14",
  Q: "28",
  2: "02",
  E: "15",
  R: "29",
  3: "03",
  F: "16",
  S: "32",
  4: "04",
  G: "17",
  T: "33",
  5: "05",
  H: "18",
  U: "34",
  6: "06",
  I: "19",
  V: "35",
  7: "07",
  J: "21",
  W: "36",
  8: "08",
  K: "22",
  X: "37",
  9: "09",
  L: "23",
  Y: "38",
  "&": "10",
  M: "24",
  Z: "39",
  A: "11",
  N: "25",
  \u00D1: "40",
  B: "12",
  O: "26"
};
const equivalencesTwo = {
  0: "1",
  17: "I",
  1: "2",
  18: "J",
  2: "3",
  19: "K",
  3: "4",
  20: "L",
  4: "5",
  21: "M",
  5: "6",
  22: "N",
  6: "7",
  23: "P",
  7: "8",
  24: "Q",
  8: "9",
  25: "R",
  9: "A",
  26: "S",
  10: "B",
  27: "T",
  11: "C",
  28: "U",
  12: "D",
  13: "E",
  14: "F",
  15: "G",
  16: "H",
  29: "V",
  30: "W",
  31: "X",
  32: "Y",
  33: "Z"
};
const equivalencesLetters = {
  0: "00",
  1: "01",
  2: "02",
  3: "03",
  4: "04",
  5: "05",
  6: "06",
  7: "07",
  8: "08",
  9: "09",
  A: "10",
  B: "11",
  C: "12",
  D: "13",
  E: "14",
  F: "15",
  G: "16",
  H: "17",
  I: "18",
  J: "19",
  K: "20",
  L: "21",
  M: "22",
  N: "23",
  O: "25",
  P: "26",
  Q: "27",
  R: "28",
  S: "29",
  T: "30",
  U: "31",
  V: "32",
  W: "33",
  X: "34",
  Y: "35",
  Z: "36",
  \u00D1: "38",
  BLANCO: "37",
  "&": "24"
};
const vowelWithAccent = {
  \u00C1: "A",
  \u00C9: "E",
  \u00CD: "I",
  \u00D3: "O",
  \u00DA: "U"
};
function removeWords(words) {
  words = ` ${words}`;
  for (let i = 0; i < toRemoveWords.length; i++) {
    words = words.replace(new RegExp(toRemoveWords[i], "gi"), " ");
  }
  return words.trim();
}
function removeNames(name) {
  name = ` ${name}`;
  for (let i = 0; i < names.length; i++) {
    name = name.replace(new RegExp(names[i], "gi"), " ");
  }
  return removeWords(name.trim());
}
function calculateQuotient(values, secuence) {
  let sum = 0;
  values.forEach((element) => {
    const multiple = element[1];
    sum += parseInt(element) * parseInt(multiple);
  });
  sum += parseInt(secuence[0][1]) * parseInt(secuence[0][1]);
  const lastThreeDigits = sum % 1e3;
  const quotient = Math.floor(lastThreeDigits / 34);
  const residue = lastThreeDigits % 34;
  const result = equivalencesTwo[quotient] + equivalencesTwo[residue];
  return result;
}
function calculateHomoClaveAndDigitalVerify(name) {
  const secuence = [];
  for (let i = 0; i < name.length; i++) {
    const character = name[i];
    const value = equivalencesOne[character];
    const add0 = i === 0 ? `0${value}` : character.includes(" ") ? "00" : value;
    if (add0) {
      secuence.push(add0);
    }
  }
  const values = [];
  const join = secuence.join("").substring(1);
  for (let i = 0; i < join.length - 1; i++) {
    values.push(join[i] + join[i + 1]);
  }
  const result = calculateQuotient(values, secuence);
  return result;
}
function formatTextRFC(text) {
  return text.toUpperCase().replace(/Á|É|Í|Ó|Ú/g, (match) => {
    return vowelWithAccent[match];
  });
}
function removeInconvenientWords(text) {
  const words = text.split(" ");
  for (let i = 0; i < words.length; i++) {
    if (inconvenientWords.includes(words[i])) {
      words[i] = `${words[i].slice(0, -1)}X`;
    }
  }
  return words.join(" ");
}
function getHomoclave(rfc) {
  let product = 0;
  for (let i = 0; i < rfc.length; i++) {
    const character = rfc[i];
    const value = equivalencesLetters[character];
    const factor = 13 - i;
    product += parseInt(value) * factor;
  }
  const residue = product % 11;
  if (residue === 0) {
    return "0";
  }
  if (residue > 0) {
    const total = Math.abs(residue - 11);
    if (total === 10) {
      return "A";
    }
    return total.toString();
  }
  return void 0;
}
function isVowel(letra) {
  return "AEIOU".includes(letra);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  calculateHomoClaveAndDigitalVerify,
  calculateQuotient,
  equivalencesLetters,
  equivalencesOne,
  equivalencesTwo,
  formatTextRFC,
  getHomoclave,
  inconvenientWords,
  isVowel,
  names,
  removeInconvenientWords,
  removeNames,
  removeWords,
  toRemoveWords,
  vowelWithAccent
});
